<template>
  <div class="lp-component-base">
    <div class="head-area">
      <img class="head-img" src="/static/img/deluxe/1/lp_head_image1.png" alt="">
      <div class="inner">
        <h1>{{ itemName }}</h1>
        <p class="target-params" v-html="deluxeInfo.item_collect.note1"></p>
        <p class="notice" v-html="deluxeInfo.item_collect.note2"></p>
      </div>
    </div>
    <div class="desc-body">

      <div v-for="(item, idx) in menusList" :key="idx">
        <playlist-item
          :class="`item-${idx}`"
          :no-fav="true"
          :item-data="item"
          :detail-force-open-trigger="item.trigger"
          @open-item="onItemClick"
        />
        <div v-if="idx == 0" class="lead-in-subsc">
          <div class="inn1">
            <div class="inn2">
              斗弥先生の鑑定はいかがでしたか？<br>
              製品版では（月額￥528、単体でのご購入は￥888）、４人がそれぞれ得意な占術を持ち寄って、あなたの恋を本格鑑定します。<br>
              ぜひご覧になってみてくださいね。
            </div>
          </div>
        </div>
      </div>

      <div class="induce-subsc" v-if="!isSubscActive">
        <div class="block-mess">
          <p>占い結果はいかがでしたか？<br>占いＴＶではこの4人の占いに加え、<br>メディアで人気の占い師による占い鑑定<br>2000メニュー以上が定額で占い放題！<br>引き続きお楽しみください。</p>
          <div class="btn-area">
            <span class="button-link" @click="onSubscButtonClick"><span class="button-face">月額登録￥{{ subscPrice }}<span class="in-tax">（税込）</span></span></span>
          </div>
        </div>
        <div class="hokatoto-link">
          <h3>占い師のページへ</h3>
          <div class="inner">
            <span
              class="item"
              v-for="(item, idx) in hokatotoMember"
              :key="idx"
              :class="`item-${item.id}`"
              @click="onHokatotoItemClick(item.id)"
            ><img :src="item.img" :alt="item.name"></span>
          </div>
        </div>
        <div class="link-area">
          <span class="retry-link" @click="onRetryClick">相手を変更してもう一度占う</span>
        </div>
      </div>
    </div>

    <floating-banner-base class="banner-base" :show-floating-banner="showFloatingBanner">
      <floating-banner-subsc
        :item-price="itemPrice"
        :subsc-price="subscPrice"
        :subsc-url="subscUrl"
        :buy-link="buyLink"
      />
    </floating-banner-base>

  </div>
</template>

<script>
import {MENU_SEC_TYPES, SEC_ICON_TYPE, MENU_ITEM_TYPE} from '@/CONSTS/MENUS'
import PlaylistItem from '@/utvStore/components/Playlist/PlaylistItem'
import FloatingBannerBase from '@/utvStore/components/recommend/lp/partials/FloatingBannerBase'
import FloatingBannerSubsc from '@/utvStore/components/recommend/lp/partials/FloatingBannerSubsc'

const IMG_BASE_URL = '/static/img/deluxe/1/'
const HOKATOTO_MEMBER = [
  {
    id: 1,
    name: 'kurenotori',
    img: `${IMG_BASE_URL}icon_kurenotori.png`,
  },

  {
    id: 2,
    name: 'kanoucoco',
    img: `${IMG_BASE_URL}icon_kanoucoco.png`,
  },
  {
    id: 3,
    name: 'touwa',
    img: `${IMG_BASE_URL}icon_touwa.png`,
  },
  {
    id: 4,
    name: 'houen',
    img: `${IMG_BASE_URL}icon_houen.png`,
  },


]

export default {
  name: 'DeluxeResultA',
  components: {
    PlaylistItem,
    FloatingBannerBase,
    FloatingBannerSubsc,
  },
  props: {
    itemName: {
      type: String,
      default: null,
    },
    subscUrl: {
      type: String,
      default: '/'
    },
    buyLink: {
      type: String,
      default: '/'
    },
    freeFlg: {
      type: Boolean,
      default: false,
    },
    itemPrice: {
      type: Number,
      default: null,
    },
    subscPrice: {
      type: Number,
      default: null,
    },
    isSubscActive: {
      type: Boolean,
      default: false,
    },
    deluxeInfo: {
      type: Object,
      default() {
        return null
      }
    },
  },
  data() {
    return {
      l_menusList: [],
      showFloatingBanner: false,
    }
  },
  computed: {
    hokatotoMember() {
      return HOKATOTO_MEMBER
    },
    menusList: {
      get() {
        if (this.l_menusList.length === 0) {
          this.deluxeInfo.menu_list.forEach((item, idx) => {
            this.l_menusList.push({
              id: idx,
              itemType: MENU_ITEM_TYPE.text,
              nonPlaylistItem: true,
              name: item.title,
              result: {
                text: item.text,
              },
              counselor: {
                id: 1,
                name: '',
                thumbnail: item.image_url,
              },
              trigger: false,
            })
          })
        }
        return this.l_menusList
      },
      set(val) {
        //トリガーのみ対応する
        for (let item of this.l_menusList) {
          if (item.id === val.id) {
            item.trigger = !item.trigger
            break
          }
        }
      }
    },
    freeButtonFace() {
      return `<span class="face-body">一部無料で占う</span><span class="notice">※ログイン不要</span>`
    },
    buyButtonFace() {
      return `購入する`
    }
  },
  mounted() {
    console.log('<received data>:\n- itemName:[%s]\n- itemPrice:[%s]\n- deluxeInfo%O\n- subscUrl:[%s]\n- subscPrice:[%s]\n- freeFlg:[%s]', this.itemName, this.itemPrice, this.deluxeInfo, this.subscUrl, this.subscPrice, this.freeFlg)
    this.onScroll()
    window.addEventListener('scroll', this.onScroll)
    this.menusList = {id: 0}
  },
  methods: {
    onScroll() {
      const bottomOffset = 100
      const sc = window.pageYOffset
      const ih = window.innerHeight
      const elm = this.$el.querySelector('.item-0')
      const elmTop = elm ? elm.offsetTop : 0
      const topOffset = elmTop + 50 - ih
      this.showFloatingBanner = !this.isSubscActive && this.freeFlg && sc > topOffset && sc < this.$el.clientHeight - ih - bottomOffset
    },
    onItemClick(val) {
      if(!this.freeFlg){
        this.menusList = {id: val.id}
      } else {
        window.gtag('event', 'click', {
          'event_category': 'Deluxe-free-result-subsc-button2',
          'event_label': '10001'
        })
        location.href = this.$handoverParams(this.subscUrl)
      }
    },
    onSubscButtonClick() {
      location.href = this.$handoverParams(this.subscUrl)
    },
    onHokatotoItemClick(val) {
      location.href = this.$handoverParams(`/recommend/lp/${val}`)
    },
    onRetryClick() {
      location.href = this.$handoverParams(this.freeFlg ? '/deluxe/10001/input/' : this.buyLink)
    },
  },
  filters: {
    priceFormat(val) {
      return `￥${String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}（税込）`
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../sass/commons/commonVariables.scss";

.lp-component-base {
  color: $col_temp_gray6;

  .head-area {
    .head-img {
      display: block;
      width: 100%;
    }

    .inner {
      padding: 16px 20px 24px;
      border-bottom: 1px solid $col_temp_gray3;

      h1 {
        color: $col_base_black;
        font-size: 18px;
        font-weight: bold;
        line-height: 23px;
        margin: 0 0 16px;
      }

      .target-params {
        padding: 14px 0;
        font-size: 16px;
        font-weight: bold;
        color: $col_temp_key1;
        margin: 0 0 24px;
        text-align: center;
        background: linear-gradient(86.53deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
        border-radius: 7px;
      }
    }
  }

  .menus-list {
    .menu-item {
      .counselor {
        background: $col_temp_key1;
        color: white;
      }
    }
  }

  .lead-in-subsc {
    background: linear-gradient(86.53deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
    border-bottom: 1px solid #DCDFE2;
    padding: 24px 20px;
    font-weight: 300;
    font-size: 16px;
    line-height: 26px;
    color: #32373F;
    .inn1 {
      background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
      padding: 1px;
      border-radius: 10px;
    }
    .inn2 {
      background: #FFFFFF;
      padding: 20px;
      border-radius: 10px;
    }
  }
}

.induce-subsc {
  width: 100%;

  .block-mess {
    width: 100%;
    padding: 40px 30px 60px;

    p {
      color: $col_base_black;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      line-height: 34px;
      margin: 0 0 40px;
    }
  }

  .hokatoto-link {
    background: #f0f0f0;
    padding:  24px 33px 24px;
    h3 {
      color: $col_base_black;
      width: 100%;
      margin: 0 0 24px;
      font-size: 20px;
      font-weight: bold;
      line-height: 1;
      text-align: center;
    }
    .inner {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        display: block;
        width: 47.5%;
        filter: drop-shadow(2px 2px 4px rgba(0,0,0,0.15));
        margin-bottom: 16px;
        img {
          width: 100%;
          display: inline-block;
          vertical-align: bottom;
        }
      }
    }

  }
  .link-area {
    width: 100%;
    padding: 40px 0;
    text-align: center;
    .retry-link {
      font-size: 16px;
      font-weight: bold;
      line-height: 1;
      color: #000;
      display: inline-block;
      text-decoration: underline;
    }
  }
}


.notice {
  font-size: 13px;
  line-height: 21px;
  color: $col_temp_gray6;

  .link {
    color: $col_temp_key1;
    font-weight: bold;
    text-decoration: underline;
    cursor: pointer;
  }
}

.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position: relative;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    box-sizing: border-box;
    border-radius: 100px;
    padding: 2px;
    width: 100%;
    height: 100%;
    background: #fff;
    background-clip: content-box;
    content: "";
  }

  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    /deep/ {
      .notice,
      .face-body {
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }

  &.disable {
    pointer-events: none;
    background: #dcdfe2;

    .button-face {
      color: #dcdfe2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}

/deep/ .floating-banner {
  height: 120px;
  overflow: hidden;
  bottom: 50px !important;
  @include mq('w580') {
    bottom: 0 !important;
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/deluxe/components/DeluxeResultA.vue